
import React from "react";
import { Scripture } from "@/hooks/prayer/types";
import { BookOpen } from "lucide-react";

interface ScriptureReferencesProps {
  scriptures: Scripture[];
}

const ScriptureReferences: React.FC<ScriptureReferencesProps> = ({ scriptures }) => {
  if (scriptures.length === 0) {
    return null;
  }
  
  return (
    <div className="mt-6">
      <h3 className="text-xl font-playfair font-bold text-selah-navy mb-4 flex items-center">
        <BookOpen className="mr-2 h-5 w-5 text-selah-gold" /> Scripture References
      </h3>
      
      <div className="space-y-4">
        {scriptures.map((scripture, index) => (
          <div key={index} className="bg-selah-gold/5 p-4 rounded-md border border-selah-gold/10">
            <h4 className="font-bold text-selah-gold mb-2">{scripture.reference}</h4>
            <p className="text-selah-navy/90 italic">{scripture.text}</p>
            {scripture.explanation && (
              <p className="mt-2 text-selah-navy/80">{scripture.explanation}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScriptureReferences;
